import * as React from "react";
import { forwardRef } from "react";
const SvgCodeBracket = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-code-icon lucide-code", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m16 18 6-6-6-6" }), /* @__PURE__ */ React.createElement("path", { d: "m8 6-6 6 6 6" }));
const ForwardRef = forwardRef(SvgCodeBracket);
export default ForwardRef;
